import { useState } from "react";
import { faqItems } from "@/mocks/home";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14">
        <div className="lg:col-span-4">
          <p className="font-label text-xs tracking-[0.2em] text-primary-700 mb-3">
            常见问题
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug mb-4">
            看之前常问的几件事
          </h2>
          <p className="text-sm md:text-base leading-7 text-foreground-600">
            合集、混剪、解说字幕版、浓缩版之间的关系，这里一次说清楚。
          </p>
        </div>

        <div className="lg:col-span-8">
          <div className="border-t border-background-300">
            {faqItems.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={item.q} className="border-b border-background-300">
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-4 py-5 text-left cursor-pointer"
                  >
                    <span className="font-heading text-base md:text-lg font-bold text-foreground-950">
                      {item.q}
                    </span>
                    <span
                      className={`w-7 h-7 shrink-0 rounded-full flex items-center justify-center transition-colors ${
                        isOpen
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                    </span>
                  </button>
                  {isOpen && (
                    <p className="pb-5 pr-10 text-sm md:text-base leading-7 text-foreground-600">
                      {item.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}